function copyHTMLFromElement(el) {
  const html = el.innerHTML;                              // preserves tags, inline styles, links
  const text = el.innerText || el.textContent || '';      // fallback plaintext

  // Modern path: ClipboardItem with text/html + text/plain
  if (navigator.clipboard && window.ClipboardItem) {
    const data = {
      'text/html': new Blob([html], { type: 'text/html' }),
      'text/plain': new Blob([text], { type: 'text/plain' })
    }; 
    return navigator.clipboard.write([new ClipboardItem(data)]);
  }

  // Fallback: execCommand('copy') via a temporary selection and 'copy' listener
  return new Promise((resolve, reject) => {
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    function onCopy(e) {
      try {
        e.clipboardData.setData('text/html', html);
        e.clipboardData.setData('text/plain', text);
        e.preventDefault(); // ensure our payload is used
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.removeEventListener('copy', onCopy, true);
        sel.removeAllRanges();
      }
    }

    document.addEventListener('copy', onCopy, true);
    const success = document.execCommand('copy');
    if (!success) {
      document.removeEventListener('copy', onCopy, true);
      sel.removeAllRanges();
      reject(new Error('execCommand(copy) failed'));
    }
  });
}

// Wire up your buttons (event delegation)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.copy');
  if (!btn) return;

  const container = btn.closest('.text-copy');
  const textEl = container && container.querySelector('.text');
  if (!textEl) return;

  if (btn.dataset.state === 'busy') return;
  btn.dataset.state = 'busy';

  const original = btn.textContent;
  copyHTMLFromElement(textEl)
    .then(() => { btn.textContent = 'Copied!'; })
    .catch(() => { btn.textContent = 'Failed'; })
    .finally(() => {
      setTimeout(() => {
        btn.textContent = original;
        btn.dataset.state = '';
      }, 1200);
    });
});